const COMPONENT_ACTION_CAPABILITIES = new Set([
  'update_summary', 'update_problem_statement', 'update_goal_statement',
  'update_target_statement', 'update_design_challenge', 'update_objectives',
  'update_deliverables', 'update_metrics', 'update_stakeholders',
  'update_design_vision', 'update_strategic_themes', 'update_opportunity_areas',
  'update_audience_insights', 'update_design_hypotheses', 'update_brief_deconstruction',
  'update_information_assessment', 'update_strategic_guidance', 'update_success_metrics',
  'update_unmet_needs', 'update_competitive_ux_positioning',
  'update_experience_design_principles', 'update_market_intelligence',
  'update_opportunity_analysis', 'update_methodology',
  'tool_duration_editing', 'add_tools_to_stages',
  'remove_tools_from_stages', 'modify_tools_content', 'bulk_actions',
  'enable_feature', 'generate_product_strategy',
  'generate_competitor_analysis', 'generate_action_plan', 'create_plan',
]);

function isComponentActionCapability(capability) {
  return COMPONENT_ACTION_CAPABILITIES.has(String(capability || ''));
}

module.exports = { COMPONENT_ACTION_CAPABILITIES, isComponentActionCapability };
